import { isApiMessageService } from "../../../chat/type-guards";
import { ApiMessage } from "../../../chat/types";

const getEnteredChatOperatorName = (message: ApiMessage) => {
  const isServiceMessage = isApiMessageService(message);
  const messageText = message.content?.text ?? "";

  const operatorEnterRegex = /Оператор ([А-Яа-яЁё]+) присоединился к диалогу/;

  const isOperatorEntering = operatorEnterRegex.test(messageText);
  const operatorName = messageText.match(operatorEnterRegex)?.[1] ?? "";

  if (isServiceMessage && isOperatorEntering && operatorName) {
    return operatorName;
  }

  return null;
};

export const getOperatorName = (message: ApiMessage): string => {
  const operatorName = getEnteredChatOperatorName(message);

  if (operatorName) {
    return `Оператор ${operatorName}`;
  }

  return "";
};
